<template>
    <div
        class="size-10 text-brand-2-950"
        v-html="SpinnerIcon"
    ></div>
</template>

<script setup>
    import SpinnerIcon from "@img/icons/spinner.svg?raw";
</script>
